
import $ from "jquery";
import * as urlMetadata from 'url-metadata';
import * as moment from 'moment';
import 'whatwg-fetch';
import 'emoji-mart/css/emoji-mart.css';
import * as EmojiMart from 'emoji-mart';
window._$ = $;
var url = window.location.hostname;
const { EventSource } = window;
const isHttps = window.location.protocol === "https" ? true : false;

const GuestUser = {
	name: "GUEST ACCOUNT",
	first_name: "GUEST",
	last_name: "ACCOUNT",
	email: null,
	phone: null,
	mobile: null,
	user_height: null,
	user_weight: null,
	id: -2,
	age: 0,
	dob: "01, January 0000",
	type: "F",
	username: "__GUEST__",
	status: "online",
	image: "server/media/default_avatar.svg",
	bg_image: "images/player_profile_cover.jpg",
	work: {
		current: [],
		past: [],
		others: []
	},
	isAdmin: false,
	isGuest: true,
	isMaster: false,
	education: {
		current: [],
		past: [],
		others: []
	},
	notices: [],
	placesLived: {
		current: [],
		past: [],
		home: [],
		others: []
	},
	basicInfo: [],
	family: [],
	isFriend: false,
	isPending: false,
	contacts: {
		social: [],
		personal: [],
	},
	sportsFollowed: [],
	friends: [],
	isUnderAge: [],
	parents: [],
	children: [],
	coaches: [],
	coaching: [],
	isParent: false,
	isCoach: false,
	isVerified: false,
	groups: [],
	teamsFollowed: [],
	myTeams: [],
	myLeauges: [],
	ownTeams: [],
	mySport: [],
	leagues: [],
	clubs: [],
	institutions: [],
	pages: [],
	notices: [],
	settings: [],
	relations: [],
	messages: [],
	events: [],
	games: [],
	online: [],
	about: "",
	aboutPrivacy: "",
	address: "",
	suburb: "",
	state: "",
	postal: "",
	country: "",
	coord: {
		lat: 0,
		lng: 0
	}
};

const MasterUser = {
	name: "GUEST ACCOUNT",
	first_name: "GUEST",
	last_name: "ACCOUNT",
	email: null,
	phone: null,
	mobile: null,
	user_height: null,
	user_weight: null,
	id: 0,
	age: 0,
	dob: "01, January 0000",
	type: "F",
	username: "__GUEST__",
	status: "online",
	image: "server/media/default_avatar.svg",
	bg_image: "images/player_profile_cover.jpg",
	work: {
		current: [],
		past: [],
		others: []
	},
	isAdmin: true,
	isGuest: false,
	isMaster: true,
	education: {
		current: [],
		past: [],
		others: []
	},
	notices: [],
	placesLived: {
		current: [],
		past: [],
		home: [],
		others: []
	},
	basicInfo: [],
	family: [],
	isFriend: false,
	isPending: false,
	contacts: {
		social: [],
		personal: [],
	},
	sportsFollowed: [],
	friends: [],
	isUnderAge: [],
	parents: [],
	children: [],
	coaches: [],
	coaching: [],
	isParent: false,
	isCoach: false,
	isVerified: false,
	groups: [],
	teamsFollowed: [],
	myTeams: [],
	myLeauges: [],
	ownTeams: [],
	mySport: [],
	leagues: [],
	clubs: [],
	institutions: [],
	pages: [],
	notices: [],
	settings: [],
	relations: [],
	messages: [],
	events: [],
	games: [],
	online: [],
	about: "",
	aboutPrivacy: "",
	address: "",
	suburb: "",
	state: "",
	postal: "",
	country: "",
	coord: {
		lat: 0,
		lng: 0
	}
};

const __ = {
	isAuthenticated: (getCookie("supotsu-user") === "" || getCookie("supotsu-user").split("-")[1] === undefined) ? false : true,
	isMaster: false,
	isGuest: false,
	isBlocked: false,
	setGuest() {
		this.isGuest = true;
	},
	setMaster() {
		this.isMaster = true;
	},
	authenticate(cb, username) {
		this.isAuthenticated = true;
		this.isMaster = false;
		this.isGuest = false;
		const cookie = FakeData.makeid(10) + "-" + username + "-" + FakeData.makeid(10);
		setCookie("supotsu-user", cookie, 60);
		setTimeout(cb, 1000)
	},
	signout(cb) {
		//this.isAuthenticated = false;
		setTimeout(() => {
			if (cb) cb();
			FakeData.setData("yoo", GuestUser);
			setCookie("supotsu-user", "", 0);
			window.location.reload(true)
		}, 1000)

	}
}

class _FakeData {
	data = {}
	EmojiMart = EmojiMart;
	name = "Supotsu-App";
	data = { yoo: GuestUser, BlockedBySystem: [], BlockedByYou: [], BlockedForYou: [] }
	io = false;
	chatIO = false;
	auth0 = __;
	EventSource = EventSource;
	shareContext = {};
	Clappr = window.Clappr;
	flvjs = window.flvjs;
	FLVJSPlayback = window.FLVJSPlayback;
	states = {};
	snacks = {};
	chats = [];
	URL = "";
	guest = GuestUser;
	admin = MasterUser;
	baseURL = "";
	$ = $;
	messaging = false;
	moment = moment;
	urlMetadata = urlMetadata;
	months = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July ',
		'August',
		'September',
		'October',
		'November',
		'December'
	];
	days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
	width = "90vw";

	constructor(url) {
		//this.URL = "http://" + url + ":8080/supotsu/public/server";
		//this.baseURL = "http://" + url + ":3000";
		var w = $("body").width();
		this.chatIO = false;

		this.Clappr = window.Clappr;
		this.flvjs = window.flvjs;
		this.FLVJSPlayback = window.FLVJSPlayback;

		$(document).ready(function () {
			$("a").click((e) => {
				const _elem = e;
				if (_elem.target.href === "") {
					const _data = {
						eventCategory: 'Drop Link',
						eventAction: 'click',
						eventLabel: e.target.href
					};
				} else {
					const _data = {
						eventCategory: 'Outbound Link',
						eventAction: 'click',
						eventLabel: e.target.href
					};

					console.log(_data);
				}
			})
		});

		this.fetchURL = window.location.protocol === 'https:'?"https://supotsu.com/server":"http://supotsu.com/server"//"http://supotsu.com:8081";
		this.apiURL = window.location.protocol === 'https:'?`https://supotsu.com:8080`:`https://supotsu.com:8080`;
		this.width = w >= 1300 ? "1300px" : w >= 990 && w < 1300 ? "960px" : "740px";
		if (process.env.NODE_ENV !== 'production') {
			this.URL = "http://supotsu.com/server";
			this.baseURL = this.getProtocol() + url + ":3000";
			console.log("Running in DevMode");
		} else {
			this.URL = "http://supotsu.com/server";
			this.baseURL = (window.location.host === "localhost:8080") ? window.location.origin + "supotsu/build" : window.location.origin;
			console.log("Running in AppMode");
		}
		this.io = false;
		this.App = {
			globals: {
				io: false
			}
		};
		this.EmojiMart = EmojiMart;
		this.data = window.localStorage.getItem("fakeDat-beta0") ? JSON.parse(window.localStorage.getItem("fakeDat-beta0")) : { "yoo": { id: null } };
	}

	socket_connect = function (room) {
		return new window.io.connect(`${this.apiURL}/wsChats`, { transports: ['websocket'], query: 'room=' + room });
	}

	getProtocol = () => {
		return isHttps ? "https://" : "http://";
	}

	setAdmin = () => {
		this.setData("yoo", MasterUser);
	}

	getFullDateString = () => {
		const d = new Date();
		const date = `${d.getFullYear()}-${d.getMonth() < 10 ? "0" + d.getMonth() : d.getMonth()}-${d.getDay() < 10 ? "0" + d.getDay() : d.getDay()} ${d.getHours() < 10 ? "0" + d.getHours() : d.getHours()}:${d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes()}:${d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds()}`;
		return date;
	};

	bytesToSize = (bytes = 0) => {
		var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
		if (bytes === 0) {
			return {
				size: 0,
				ext: 'byte'
			}
		}

		var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
		return {
			size: Math.round(bytes / Math.pow(1024, i), 2),
			ext: sizes[i]
		}
	}

	setGuest = () => {
		this.setData("yoo", GuestUser);
	}

	shortDigit = (num, suffix = "") => {
		const _num = this.numify(num);
		const _suffix = this.nullify(suffix).toLowerCase();
		const _text = parseInt(this.nFormatter(_num)) === 0 ? "" : this.nFormatter(_num) + " ";
		const _ext = parseInt(this.nFormatter(_num)) === 0 ? _suffix.capitalize() : parseInt(this.nFormatter(_num)) === 1 ? _suffix : _suffix === "" ? _suffix : _suffix.plural();
		const value = {
			text: this.nFormatter(_num, 1),
			isSingle: (_num / 6) > 1000000 ? false : ((_num / 3) > 1000) ? false : (_num === 1) ? true : (_num === 0) ? false : false,
			data: _text + "" + _ext
		}

		return value;
	}

	pluralize = (str) => {

	}

	getPath = (user, search = "?sInit=about") => {
		let path = { pathname: "/", search };
		const _user = user.user | user.username | user.id;
		if (!_user) {
			return path;
		}
		switch (user.type) {
			case "F":
				path.pathname = "/profile/" + _user;
				break;
			case "P":
				path.pathname = "/profile/" + _user;
				break;
			case "T":
				path.pathname = "/team/" + user.id;
				break;
			case "C":
				path.pathname = "/club/" + _user;
				break;
			case "I":
				path.pathname = "/institution/" + _user;
				break;
			case "L":
				path.pathname = "/tournament/" + _user;
				break;
			case "E":
				path.pathname = "/event/" + user.id;
				break;
			case "Q":
				path.pathname = "/group/" + _user;
				break;
			case "G":
				path.pathname = "/game/" + user.id;
				path.search = "";
				break;
			default:
				path.pathname = "/";
				path.search = "";
				break;
		}

		return path;
	}

	withSettings = ({ component, settings, user }) => {
		return { component };
	}

	nFormatter = (num, digits = 1) => {
		var si = [
			{ value: 1E18, symbol: "E" },
			{ value: 1E15, symbol: "P" },
			{ value: 1E12, symbol: "T" },
			{ value: 1E9, symbol: "G" },
			{ value: 1E6, symbol: "M" },
			{ value: 1E3, symbol: "k" }
		], rx = /\.0+$|(\.[0-9]*[1-9])0+$/, i;

		for (i = 0; i < si.length; i++) {
			if (num >= si[i].value) {
				return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
			}
		}
		return num.toFixed(digits).replace(rx, "$1");
	}

	getRandomInt = (min, max) => {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}

	loaderElement = () => {
		return document.querySelector(".async-loader");
	}

	toMyTimezone = (dateString) => {
		var myDate = new Date(dateString);
		var date = new Date();
		if (myDate.getTimezoneOffset() === date.getTimezoneOffset()) {
			//return myDate;
			myDate.setMinutes(myDate.getMinutes() + myDate.getTimezoneOffset());
			return myDate;
		}
		myDate.setMinutes(myDate.getMinutes() - myDate.getTimezoneOffset());
		return myDate;
	}

	today = () => {
		var date = new Date();
		date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
		return {
			fullDate: this.days[date.getDay()] + ", " + date.getDate() + " " + this.months[date.getMonth()] + " " + date.getFullYear(),
			context: {
				months: this.months,
				days: this.days,
				dateObj: date
			}
		};
	}

	getDummy = (_num, obj = null) => {
		const list = [];
		for (var index = 0; index < _num; index++) {
			list.push(obj === null ? { text: index } : obj)
		}

		return list;
	}

	getRGB(b) {
		var a;
		if (b && b.constructor == Array && b.length == 3) {
			return b;
		}

		if (a = /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/.exec(b)) {
			return [parseInt(a[1]), parseInt(a[2]), parseInt(a[3])];
		}

		if (a = /rgb\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*\)/.exec(b)) {
			return [parseFloat(a[1]) * 2.55, parseFloat(a[2]) * 2.55, parseFloat(a[3]) * 2.55];
		}

		if (a = /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/.exec(b)) {
			return [parseInt(a[1], 16), parseInt(a[2], 16), parseInt(a[3], 16)];
		}

		if (a = /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/.exec(b)) {
			return [parseInt(a[1] + a[1], 16), parseInt(a[2] + a[2], 16), parseInt(a[3] + a[3], 16)];
		}

		return (typeof (a) != "undefined") ? a[window.jQuery.trim(b).toLowerCase()] : null
	};

	getLuminance(color) {
		var rgb = this.getRGB(color);
		if (!rgb) {
			return null;
		}
		const lum = 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
		const _color = (lum > 180) ? "#000000" : "#ffffff";
		return _color;
	}

	alert = (txt) => {
		var el = document.createElement("div");
		var id = FakeData.makeid(txt.length);
		el.className = "snack-bar " + id;
		var sbText = document.createElement("span");
		sbText.className = "sb-text";
		el.appendChild(sbText);

		var sbAction = document.createElement("span");
		sbAction.className = "sb-action";
		el.appendChild(sbAction);
		sbText.textContent = txt;
		sbAction.textContent = "OK";

		this.setSnack(id, el);
	}

	setData = (key, data, cb = false) => {
		this.data[key] = data;
		try {
			window.localStorage.setItem("fakeDat-beta0", JSON.stringify(this.data))
			if (cb) {
				cb()
			}
		} catch (error) {
			if (cb) {
				cb()
			}
		}
	}

	___ = (type = false, config = {}, profile = GuestUser, settings = []) => {
		let __config = {};
		const _ = Object.keys(config);

		if (profile.isAdmin || !type || type === "G") {
			_.forEach((item, i) => {
				__config[item] = true;
			})

			return __config;
		};

		profile.settings.forEach((item, i) => {
			if (config[item.sub]) {
				const _bool = (typeof item.value === "string" || typeof config[item.sub] === "string") ? true : false;
				if (_bool) {
					__config[item.sub] = (!profile.isFriend && item.value === "Friends") ? false : (item.value === "Public") ? true : false;
				} else {
					if (typeof config[item.sub] === "array") {
						__config[item.sub] = item.users;
					} else {
						__config[item.sub] = item.value;
					}
				}
			}
		})

		_.forEach((item, i) => {
			if (!__config[item]) {
				__config[item] = typeof config[item] === "string" ? true : false;
			}
		})

		return __config;
	}

	getData = (key = "yoo") => {
		if (key == "yoo") {
			return this.data.yoo
		}
		return this.data[key];
	}

	mountState = (key, bool) => {
		this.states[key] = bool;
	}

	isMounted = (key) => {
		return this.states[key];
	}

	deleteData = (key) => {
		delete this.data[key];
		return this
	}

	listify = (list) => {
		if (Array.isArray(list)) {
			return list;
		} else {
			return [];
		}
	}

	inArray = (item, array) => {
		if (this.listify(array).indexOf(item) === -1) {
			return false;
		} else {
			return true;
		}
	}

	_getBlocked = (id, type, arr = []) => {
		const _list = arr.filter((item, i) => {
			return item.user_id === id && item.user_type === type;
		});

		return _list.length > 0 ? true : false;
	}

	getBlocked = (context, objOnly = true, types = [], blockTypes = []) => {
		const { props } = context;
		if (objOnly) {
			return {
				BlockedBySystem: this.listify(props['BlockedBySystem'] ? props['BlockedBySystem'] : this.getData('BlockedBySystem')),
				BlockedByYou: this.listify(props['BlockedByYou'] ? props['BlockedByYou'] : this.getData('BlockedByYou')),
				BlockedForYou: this.listify(props['BlockedForYou'] ? props['BlockedForYou'] : this.getData('BlockedForYou'))
			};
		} else {
			const _list = [];
			const _obj = {
				BlockedBySystem: this.listify(props['BlockedBySystem'] ? props['BlockedBySystem'] : this.getData('BlockedBySystem')),
				BlockedByYou: this.listify(props['BlockedByYou'] ? props['BlockedByYou'] : this.getData('BlockedByYou')),
				BlockedForYou: this.listify(props['BlockedForYou'] ? props['BlockedForYou'] : this.getData('BlockedForYou'))
			};

			_obj.BlockedBySystem.forEach((item, i) => {
				if (this.inArray(item.user_type, types) && !this.inArray(item.user_id, _list) && !(blockTypes.length > 0 && !this.inArray(item.type, blockTypes))) {
					_list.push(item.user_id);
				}
			})

			_obj.BlockedByYou.forEach((item, i) => {
				if (this.inArray(item.user_type, types) && !this.inArray(item.user_id, _list) && !(blockTypes.length > 0 && !this.inArray(item.type, blockTypes))) {
					_list.push(item.user_id);
				}
			})

			_obj.BlockedForYou.forEach((item, i) => {
				if (this.inArray(item.user_type, types) && !this.inArray(item.user_id, _list) && !(blockTypes.length > 0 && !this.inArray(item.type, blockTypes))) {
					_list.push(item.user_id);
				}
			})

			return _list;
		}
	}

	nullify = (string) => {
		return new String(string);
	}

	getRichText = (txt = "", arr) => {
		//const _content; 
		let text = txt;
		if (arr instanceof Array || !arr) {
			return txt;
		} else {
			const Keys = Object.keys(arr);
			Keys.forEach((key) => {
				if (arr[key]) {
					const _list = this.getBlocked({ props: {} }, false, [arr[key]['type']]);
					const _isBlocked = (this.inArray(arr[key]['id'], _list)) ? true : false;
					const _link = _isBlocked ? "<a class=\"disabled\"><b>" + arr[key]['name'] + "</b></a>" : `<a href="${"/profile/" + arr[key]['user'] + "?sInit=about"}"><b>${arr[key]['name']}</b></a>`
					const content = (_isBlocked ? `<i class="material-icons" style="font-size:10px;margin:0px 2px 0px 5px">block</i>` : "") + _link;
					const _replace = "%" + key + "%";
					text = text.replace(_replace, content);
				}
			})

			return text;
		}
	}

	getSettingValue = (tag = "", settings = [], returnType = "bool") => {
		let bool = returnType === "bool" ? true : "Friends";
		settings.forEach((item, i) => {
			if (item.sub === tag) {
				bool = item.value;
			}
		});

		return bool;
	}

	numify = (num) => {
		return parseInt(num);
	}

	makeDatePicker = (el, cb) => {
		if (el === null) {
			return
		}
		var val = window.$(el).val()

		window.$(el).datepicker();

		window.$(el).off("change").bind("change", function (e) {
			if (cb) {
				cb.call(this, e)
			}
		})
	}

	makeTimePicker = (el, cb) => {
		if (el === null) {
			return
		}

		window.$(el).timepicker();
		window.$(el).off("change").bind("change", function (e) {
			if (cb) {
				cb.call(this, e)
			}
		})
	}

	setSnack = (key, data) => {
		this.snacks[key] = data;
		document.body.appendChild(data);
		setTimeout(function () {
			document.body.removeChild(data);
		}, 2500);
	}

	shared = (key, context) => {
		var isContext = Boolean(context)
		if (!isContext) {
			return this.shareContext[key]
		} else {
			this.shareContext[key] = context
			return this
		}
	}

	makeid = (len) => {
		var text = "";
		var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

		for (var i = 0; i < len; i++) {
			text += possible.charAt(Math.floor(Math.random() * possible.length));
		}
		return text;
	}

	blob = (src, callbacks) => {
		fetch(src).then(function (response) {
			return response.blob()
		}).then(function (response) {
			var objectURL = URL.createObjectURL(response);
			callbacks.success(objectURL)
		}).catch(function (ex) {
			callbacks.error(ex)
		})
	}

	hasUserMedia = () => {
		//check if the browser supports the WebRTC 
		return !!(navigator.getUserMedia || navigator.webkitGetUserMedia ||
			navigator.mozGetUserMedia);
	}

	upload = (path, _data, callbacks = {
		success(res) { },
		error(err) { }
	}, isSnack) => {
		var isSetSnack = Boolean(isSnack);
		const _that = this;
		var url = (this.isWebsite(path)) ? path : FakeData.fetchURL + path;
		if (isSetSnack) {
			_that.loaderElement().style.marginBottom = "2cm";
		}

		fetch(url, {
			method: 'POST',
			body: _data
		})
			.then(r => r.json())
			.then(data => {
				if (isSetSnack) {
					_that.loaderElement().style.marginBottom = "-2cm";
				}
				if (callbacks.success) {
					callbacks.success(data)
				}
			}).catch((err) => {
				if (callbacks.error) {
					callbacks.error(err)
				}
			})
	}

	fetch = (path, _data, callbacks = {
		success(res) { },
		error(err) { },
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	}, isSnack) => {
		var isSetSnack = Boolean(isSnack);
		const _that = this;
		var url = (this.isWebsite(path)) ? path : FakeData.fetchURL + path;
		if (isSetSnack) {
			_that.loaderElement().style.marginBottom = "2cm";
		}
		const _method = callbacks.method ? this.nullify(callbacks.method) : "POST";
		const _headers = callbacks.headers ? callbacks.headers : {
			'Content-Type': 'application/x-www-form-urlencoded'
		};

		fetch(url, {
			method: _method,
			body: _data,
			headers: _headers
		})
			.then(r => r.json())
			.then(data => {
				if (isSetSnack) {
					_that.loaderElement().style.marginBottom = "-2cm";
				}
				if (callbacks.success) {
					callbacks.success(data)
				}
			}).catch((err) => {
				if (callbacks.error) {
					callbacks.error(err)
				}
			})
	}

	support = () => {
		return {
			email: "9409promos@gmail.com"
		}
	}

	post = (path, _data, callbacks = {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		method: 'POST',
		success(res) { },
		error(err) { }
	}, isSnack, sbTextTxt, sbActionFunc) => {
		const _that = this;
		if (!_that.getData("sp-data-" + path)) {
			//_that.setData("sp-data-"+path, false);
		}

		let data = _data;
		data['reqOwner'] = {
			id: this.getData("yoo").id,
			type: "F",
			name: this.getData("yoo").name,
			email: this.getData("yoo").email
		}

		var isSetSnack = Boolean(isSnack);
		var isSetSnackText = Boolean(sbTextTxt);
		var isSetSnackAction = Boolean(sbActionFunc);

		var url = (this.isWebsite(path)) ? path : `${_that.apiURL}/php/server` + path;
		const headers = callbacks.headers ? callbacks.headers : {
			'Content-Type': 'application/x-www-form-urlencoded'
		};

		if (isSetSnack) {
			var el = document.createElement("div");
			var id = _that.makeid(path.length);
			el.className = "snack-bar " + id;
			var sbText = document.createElement("span");
			sbText.className = "sb-text";
			el.appendChild(sbText);

			var sbAction = document.createElement("span");
			sbAction.className = "sb-action";
			el.appendChild(sbAction);

			_that.loaderElement().style.marginBottom = "2cm";
			const method = callbacks.method ? this.nullify(callbacks.method) : "POST"
			this.$.ajax({
				type: method,
				url: url,
				data: _that.stringify(data),
				beforeSend(request) {
					//request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
				},
				headers,
				success(result) {
					//var json = JSON.parse(result);
					sbAction.onclick = function (evt) {
						sbActionFunc.call(this, result)
					}
					sbText.textContent = sbTextTxt;
					sbAction.textContent = "OK";
					if (sbTextTxt !== "") {
						_that.setSnack(id, el)
					}
					if (callbacks.success) {
						callbacks.success(result)
						//window.localStorage.setItem("supotsu-"+url, result)
						//_that.setData("sp-data-"+path, false)
						//console.log(result)
					}
					_that.loaderElement().style.marginBottom = "-2cm";
					//console.log(result)
				},
				error(err) {
					if (callbacks.error) {
						callbacks.error(err)
					}
					sbAction.textContent = "TRY AGAIN";
					sbAction.onclick = function (evt) {
						_that.post(path, data, callbacks, isSnack, sbTextTxt, sbActionFunc)
					}

					const bool = Boolean(_that.getData("sp-data-" + path));
					if (bool) {
						if (callbacks.success) {
							callbacks.success(_that.getData("sp-data-" + path))
						}
					} else {
						sbText.textContent = "Network Error";

						_that.setSnack(id, el)
					}

					_that.loaderElement().style.marginBottom = "-2cm";
				}
			})
		} else {
			const method = callbacks.method ? this.nullify(callbacks.method) : "POST"
			this.$.ajax({
				type: method,
				url: url,
				data: _that.stringify(data),
				beforeSend(request) {
					//request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
				},
				headers,
				success(result) {
					if (callbacks.success) {
						callbacks.success(result)
						//_that.setData("sp-data-"+path, result)
					}
				},
				error(err) {
					if (callbacks.error) {
						callbacks.error(err)
					}
				}
			})
		}

	}

	postHttp = (path, data, callbacks, isSnack, sbTextTxt, sbActionFunc) => {
		const _that = this
		var isSetSnack = Boolean(isSnack);
		var isSetSnackText = Boolean(sbTextTxt);
		var isSetSnackAction = Boolean(sbActionFunc);

		if (isSetSnack) {
			var el = document.createElement("div");
			var id = _that.makeid(path.length);
			el.className = "snack-bar " + id;
			var sbText = document.createElement("span");
			sbText.className = "sb-text";
			el.appendChild(sbText);

			var sbAction = document.createElement("span");
			sbAction.className = "sb-action";
			el.appendChild(sbAction);

			_that.loaderElement().style.marginBottom = "2cm";

			fetch((this.isWebsite(path)) ? path : _that.URL + path, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				body: _that.stringify(data)
			}).then(function (response) {
				_that.loaderElement().style.marginBottom = "-2cm";
				return response.json()
			}).then(function (json) {
				sbAction.onclick = function (evt) {
					sbActionFunc.call(this, json)
				}
				sbText.textContent = sbTextTxt;
				sbAction.textContent = "OK";
				if (sbTextTxt !== "") {
					_that.setSnack(id, el)
				}

				callbacks.success(json)
			}).catch(function (ex) {
				callbacks.error(ex)
				console.log(ex)
				sbAction.textContent = "TRY AGAIN";
				sbAction.onclick = function (evt) {
					_that.post(path, data, callbacks, isSnack, sbTextTxt, sbActionFunc)
				}


				sbText.textContent = "Network Error";

				_that.setSnack(id, el)
			})
		} else {
			fetch((this.isWebsite(path)) ? path : _that.URL + path, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				body: _that.stringify(data)
			}).then(function (response) {
				//console.log(response);

				return response.json()
			}).then(function (json) {
				callbacks.success(json)
			}).catch(function (ex) {
				callbacks.error(ex)
			})
		}
	}

	getTMP = (path, callbacks) => {
		fetch(path, {
			method: 'GET'
		}).then(function (response) {
			console.log(response);
			return response.json()
		}).then(function (json) {
			callbacks.success(json)
		}).catch(function (ex) {
			callbacks.error(ex)
		})
	}

	setTitle = (chars) => {
		if (document.title === chars) {
			return;
		}

		document.title = chars
	}

	getQueries = (str) => {
		var obj = {};
		var array = str.slice(1).split("&");
		for (var x = 0; x < array.length; x++) {
			var strOf = array[x].split("=");
			obj[strOf[0]] = unescape(strOf[1]);
		}

		return obj;
	}

	isEmail = (email) => {
		var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}

	isWebsite = (website) => {
		var WEB_REGEXP = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
		return WEB_REGEXP.test(website);
	}

	isPhone = (phone) => {
		var PHONE_REGEXP = /\(?([0-9]{2,3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
		return PHONE_REGEXP.test(phone);
	}

	getProfileStyle = (bg, col, bdColor) => {
		const style = {
			".top-sports > img:hover,.top-sports > img.active , img.with-hover:hover": {
				background: bg,
			},
			".top-other-item": {
				color: col
			},
			".top-other-item:hover,.top-other-item.active": {
				color: bg
			},
			".top-other-item:hover > img,.top-other-item.active > img": {
				background: bg
			},
			".sport-details > div:first-child": {
				color: col
			},
			".sport-detail": {
				"border-color": col
			},
			".sport-detail > span:first-child": {
				color: bg
			},
			".sport-details > div:last-child": {
				color: col,
			},
			".sport-detail-graph > span": {
				color: col,
			},
			".sport-detail-graph > div": {
				color: bg,
			},
			".sport-detail-graph.chart > div": {
				color: col,
			},
			".sport-detail-graph.chart > div::before,.sport-detail-graph.chart > div div": {
				"border-color": bg,
				"border-top-color": col,
				"position":"absolute"
			},
			".other-details-add": {
				color: col,
			},
			".other-details-add > a": {
				color: col,
			},
			".profile-banner-main-picture > div.back-photo,.profile-banner-main-picture > div.front-photo": {
				color: col,
			},
			".profile-banner-nav > div": {
				color: col,
			},
			".profile-banner-nav > div.active,.profile-banner-nav > div:hover": {
				color: bg
			},
			".teams-min-slider": {
				color: col,
			},
			".view-with-tabs-head": {
				color: col,
			},
			".view-with-tabs-head-item": {
				background: bg,
			},
			".view-with-tabs-head-item:hover": {
				background: bdColor,
				color: bg
			},
			".view-with-tabs-head-item.active": {
				background: col,
				color: bg
			},
			".view-with-tabs-head-item.active": {
				background: col,
				color: bg
			},
			".up-gm-item > span": this.genStyle("background", bg, col, true, 1.0),
			".next_game_header": this.genStyle("background", bg, col, true, 1.0),
			".league-split-view > .next-game-view > .next_game_counter > div": this.genStyle("background", bg, col, true, 0.5),
			".upcoming-games-view-tabs.league > span": this.genStyle("background", bg, col, false, 0.0),
			".upcoming-games-view-tabs.league > span.active": this.genStyle("background", col, bg, false, 0.0),
			".upcoming-games-view-tabs.league > span:hover": this.genStyle("background", bg, col, false, 0.0),
			".upcoming-games-view > .load-more.league": this.genStyle("background", bg, col, false, 0.0),
			".upcoming-games-view > .load-more.league:hover": this.genStyle("background", bg, col, true, 0.6),
			".upcoming-games-view-head.league > *:hover": this.genStyle("background", bg, col, false, 0.0),
			".upcoming-games-view-head.league > .active": this.genStyle("background", bg, col, false, 0.0),
			".event-list-view-tab": this.genStyle("background", bg, col, false, 0.0),
			".event-list-view-tab.active": this.genStyle("background", col, bg, false, 0.0),
			".event-list-view-tab:hover": this.genStyle("background", col, bg, false, 0.0),
			".event-view-pane-tab.active": this.genStyle("background", bg, bg, false, 0.0),
			".event-view-pane-tab.active": this.genStyle("border-color", bg, bg, false, 0.0),
			".internal-notice-center-head": this.genStyle("background-color", bg, col, false, 0.0)
		}

		return style;
	}

	getRGB = (hex, a = 1) => {
		var c;
		if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
			c = hex.substring(1).split('');
			if (c.length == 3) {
				c = [c[0], c[0], c[1], c[1], c[2], c[2]];
			}
			c = '0x' + c.join('');
			return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + a + ')';
		}
		throw new Error('Bad Hex');
	}

	genStyle = ($prop, $val, $col, $isAlpha, $alpha) => {
		if ($isAlpha) {
			const $array = {
				"color": $col + "!important"
			};

			$array[$prop] = this.getRGB($val, $alpha) + "!important";

			return $array;
		}

		const $array = {
			"color": $col + "!important"
		};

		$array[$prop] = $val + "!important";

		return $array;
	}

	setCookie = (cname, cvalue, exdays) => {
		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	getCookie = (cname) => {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	stringify = (obj, replacer, spaces, cycleReplacer) => {
		return JSON.stringify(obj, this.serializer(replacer, cycleReplacer), spaces)
	}

	you = () => {
		return this.getData("yoo");
	}

	unbr = (str = "") => {
		return str.replace(/<br[^>]*>/g, "\n")
	}

	br = (str = "") => {
		return str.replace(/\r?\n/g, '<br/>');
	}

	serializer = (replacer, cycleReplacer) => {
		var stack = [], keys = []

		if (cycleReplacer == null) cycleReplacer = function (key, value) {
			if (stack[0] === value) return "[Circular ~]"
			return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
		}

		return function (key, value) {
			if (stack.length > 0) {
				var thisPos = stack.indexOf(this)
				~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
				~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
				if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
			}
			else stack.push(value)

			return replacer == null ? value : replacer.call(this, key, value)
		}
	}

	onKeyPress = (e) => {
		if ((e.keyCode === 13 || e.which === 13)) {
			e.preventDefault()
		}
	}
}

function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

const FakeData = new _FakeData(url);
console.log('window', FakeData.Clappr)
export default FakeData;



// WEBPACK FOOTER //
// ./src/fake-data.js